import { HomepageBannerCarousel } from '@/src/homepage/components/HomepageBannerCarousel';
import { GuidesCarousel } from '@/src/homepage/components/guides/GuidesCarousel';
import type { Guides } from '@/src/homepage/types/guides';

export function HeroBanner({
    showGuides,
    locale,
    initialGuides,
    littleVeniceSpotlightEnabled,
}: {
    showGuides: boolean;
    locale: string;
    initialGuides?: Guides;
    littleVeniceSpotlightEnabled?: boolean;
}) {
    return (
        <GuidesCarousel showGuidesCarousel={showGuides} initialGuides={initialGuides}>
            <HomepageBannerCarousel
                locale={locale}
                littleVeniceSpotlightEnabled={littleVeniceSpotlightEnabled}
            />
        </GuidesCarousel>
    );
}
